<template>
  <div class="login-container">
    <Modal v-model="showList" @on-cancel="close" width="800" class-name="vertical-center-modal">
      <Form ref="formValidate">
        <div class="title">新增清单</div>
        <FormItem prop="name">
          <label>电邮*</label>
          <Input v-model="flodlerName" />
        </FormItem>
        <FormItem>
          <div class="btn">
            <span class="btn-text">请继续</span>
          </div>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "User",
  data() {
    return {
      flodlerName: ""
    };
  },
  props: {
    showList: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/style/login.less";

.title {
  color: #5c5d5f;
  font-size: 1.2rem;
  line-height: 1.67;
  margin-bottom: 5rem;
}

/deep/.ivu-modal-body {
  padding: 3rem 3rem 1.4rem;
}

/deep/ .ivu-form-item-content {
  flex-direction: column;
  width: 50%;
  color: #959595;
}
/deep/.ivu-modal-close {
  display: block;
}
/deep/.ivu-modal-close .ivu-icon-ios-close {
  color: #5c5d5f;
}
.btn {
  width: 12rem;
  text-align: center;
  margin-top: 3.4rem;
  .btn-text {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/AddList.vue